import React, { useEffect } from "react";

import { Helmet } from 'react-helmet-async';
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MembAccnDtlInfoUi from "./MembAccnDtlInfoUi";
import MembGameSvcMnyUi from "./MembGameSvcMnyUi";
import MembOtpRegChkInqUi from "./MembOtpRegChkInqUi";
import MembPrfLangSetUi from "./MembPrfLangSetUi";
import "Assets/css/MyPage.css";
import MembMktgAgreUi from "./MembMktgAgreUi";
import MembQnaTop1Ui from "./MembQnaTop1Ui";
import MgpStore from "Stores/Store";

const MyPage =() => {
    const langData:any = useOutletContext();
     const navigate = useNavigate();
    // Redux selector로 실시간 감지
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00}</p>
            </div>
            {/* 회원정보 */}
            <div className="myPageCardWrap">
                <MembAccnDtlInfoUi langData={langData}/>
                <div className="myPageCardWrapRight">
                    <MembGameSvcMnyUi langData={langData}/>
                    <MembOtpRegChkInqUi langData={langData}/>
                    {/* <MembPrfLangSetUi langData={langData}/> */}
                </div>
                <MembQnaTop1Ui langData={langData} />
                {   idntMthdCd&&idntMthdCd === "NA"?
                    <></> :
                    <MembMktgAgreUi langData={langData}/>
                }
            </div>
        </div>
        </>
    )
}


export default MyPage;